<template>
  <div class="yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)]">
    <navBar></navBar>
    <div class="flex flex-col items-center justify-center mt-10">
      <img class="w-18 h-18" :src="filterStatus().icon" :alt="filterStatus().text" />
      <p class="text-center text-lg mt-4">{{ filterStatus().text }}</p>

      <div class="flex mt-10">
        <van-button
          v-if="isLoggedIn && payInfo.status == '00'"
          type="primary"
          color="#ff7a00"
          class="w-30 h-9 rounded-xl mr-3"
          @click="goOrder">
          {{ $t("pay.goOrderDetail") }}
        </van-button>
        <van-button type="primary" color="#ff7a00" class="w-30 h-9 rounded-xl" @click="goHome">
          {{ $t("common.goHome") }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  data() {
    return {
      key: "",
      successSrc: require("@/assets/images/icon_jyxq_cg.png"),
      failedSrc: require("@/assets/images/icon_jyxq_shb.png"),
      ProcessSrc: require("@/assets/images/wx_img_loading.png"),

      payInfo: {},
    }
  },
  computed: {
    ...mapGetters({
      isZh: "lang/isZh",
      isLoggedIn: "auth/isLoggedIn",
    }),
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/" })
    },
    filterStatus() {
      const status = this.payInfo.status
      const statusInfo = {}
      if (status == "00") {
        statusInfo.text = this.$t("pay.PaySuccess")
        statusInfo.icon = this.successSrc
      } else if (status == "11") {
        statusInfo.text = this.$t("pay.PayFailed")
        statusInfo.icon = this.failedSrc
      } else if (status == "22") {
        statusInfo.text = this.$t("pay.PayProcessing")
        statusInfo.icon = this.ProcessSrc
      }
      return statusInfo
    },
    goOrder() {
      this.$router.push({
        name: "orderDetail",
        query: {
          orderNo: this.payInfo.orderid,
        },
      })
    },
  },
  created() {
    // 获取路由中信息
    console.log(this.$route.query)
    this.payInfo = this.$route.query
  },
}
</script>

<style scoped></style>
